import { render, staticRenderFns } from "./K3Upload.vue?vue&type=template&id=6fc2d8a4&scoped=true&"
import script from "./K3Upload.vue?vue&type=script&lang=js&"
export * from "./K3Upload.vue?vue&type=script&lang=js&"
import style0 from "./K3Upload.vue?vue&type=style&index=0&id=6fc2d8a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc2d8a4",
  null
  
)

export default component.exports